export default __webpack_public_path__ + "static/media/shoT1.6d2229f4.jpg";